<template>
  <!-- 入库唛头打印 -->
  <div class="up-storage-entry-label">
    <div class="label-section label-header">
      <div class="print-date">打印日期：{{ viewData.print_date }}</div>
      <div class="customer-level" v-if="viewData.customer_level">{{ viewData.customer_level }}</div>
      <div class="customer-info">
        <span class="label-name">客户信息：</span>
        <span class="label-value">{{ viewData.customer_info }}</span>
      </div>
    </div>
    <div class="label-section entry-section">
      <div class="section-title">入库码</div>
      <div class="entry-code">{{ viewData.entry_no }}</div>
    </div>
    <div class="label-section grid-section">
      <div class="section-title">库位</div>
      <div class="grid-code">{{ viewData.grid_text }}</div>
    </div>
    <div class="barcode-section">
      <canvas ref="barcode" width="1000" height="180"></canvas>
      <div class="barcode-text">{{ viewData.entry_code }}</div>
      <div class="staff-row">
        <div>业务：{{ viewData.salesman_name }}</div>
        <div>采购：{{ viewData.purchaser_name }}</div>
        <div>打印人：{{ viewData.printer_name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpStorageEntryLabel',
  props: {
    labelData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    viewData() {
      const data = this.labelData || {}
      return {
        print_date: data.print_date || '',
        customer_level: data.customer_level || '',
        customer_info: data.customer_info || '',
        entry_no: data.entry_no || '',
        grid_text: data.grid_text || '',
        entry_code: data.entry_code || '',
        salesman_name: data.salesman_name || '',
        purchaser_name: data.purchaser_name || '',
        printer_name: data.printer_name || ''
      }
    }
  },
  mounted() {
    this.createBarcode()
  },
  watch: {
    labelData: {
      deep: true,
      handler() {
        this.$nextTick(this.createBarcode)
      }
    }
  },
  methods: {
    // 根据接口返回的入库码字段生成一维码
    createBarcode() {
      if (!this.$refs.barcode || !this.viewData.entry_code) return
      JsBarcode(this.$refs.barcode, this.viewData.entry_code, {
        format: 'CODE128',
        displayValue: false,
        height: 180,
        width: 3,
        margin: 0,
        lineColor: '#000000'
      })
    }
  }
}
</script>

<style scoped>
.up-storage-entry-label {
  width: 1080px;
  height: 1600px;
  color: #000;
  background: #fff;
  border: 5px solid #000;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", SimHei, Arial, sans-serif;
  overflow: hidden;
  margin: 40px;
}

.label-section {
  border-bottom: 5px solid #000;
  box-sizing: border-box;
}

.label-header {
  position: relative;
  height: 320px;
  padding: 34px 36px;
}

.print-date {
  font-size: 32px;
  line-height: 42px;
}

.customer-level {
  position: absolute;
  top: 26px;
  right: 42px;
  font-size: 64px;
  font-weight: 700;
  line-height: 78px;
}

.customer-info {
  margin-top: 112px;
  font-size: 48px;
  line-height: 64px;
  white-space: nowrap;
}

.label-name {
  font-weight: 400;
}

.label-value {
  font-weight: 700;
}

.entry-section {
  height: 350px;
  padding: 48px 36px 20px;
}

.grid-section {
  height: 350px;
  padding: 54px 36px 20px;
}

.section-title {
  font-size: 68px;
  font-weight: 700;
  line-height: 84px;
}

.entry-code,
.grid-code {
  margin-top: 50px;
  font-size: 150px;
  font-weight: 700;
  line-height: 174px;
  white-space: nowrap;
}

.barcode-section {
  height: 500px;
  padding: 72px 36px 20px;
  box-sizing: border-box;
  text-align: center;
}

.barcode-section canvas {
  display: block;
  width: 1000px !important;
  height: 180px !important;
  margin: 0 auto;
}

.barcode-text {
  margin-top: 18px;
  font-size: 40px;
  font-weight: 700;
  line-height: 52px;
}

.staff-row {
  display: flex;
  justify-content: space-between;
  margin-top: 100px;
  padding: 0 22px;
  font-size: 40px;
  font-weight: 700;
  line-height: 52px;
  text-align: left;
}
</style>
